import React from 'react';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';

function isNumeric(n) {
  return !Number.isNaN(parseFloat(n)) && Number.isFinite(n);
}

function GridBlock(props) {
  const {
    RecursiveComponent,
    alignContent = 'stretch',
    alignItems = 'stretch',
    direction = 'row',
    justify = 'flex-start',
    spacing = 0,
    cells = [],
  } = props;

  return (
    <Grid
      container
      alignContent={alignContent}
      alignItems={alignItems}
      direction={direction}
      justifyContent={justify}
      spacing={spacing}
    >
      {
        cells.map((cell) => {
          let {
            xs = false,
            sm = false,
            md = false,
            lg = false,
          } = cell;
          const {
            content = [],
            textAlign = 'inherit',
          } = cell;
          if (isNumeric(xs)) xs = parseInt(xs, 10);
          if (isNumeric(sm)) sm = parseInt(sm, 10);
          if (isNumeric(md)) md = parseInt(md, 10);
          if (isNumeric(lg)) lg = parseInt(lg, 10);
          return (
            <Grid xs={xs} lg={lg} md={md} sm={sm} item sx={{ textAlign }}>
              <RecursiveComponent value={content} nested />
            </Grid>
          );
        })
      }
    </Grid>
  );
}

export default GridBlock;
